<template>
  <div class="container mt-4">
    <div class="card">
      <div class="card-header">
        <h3>{{ isEditing ? 'Edit Department' : 'Add New Department' }}</h3>
      </div>
      <div class="card-body">
        <form @submit.prevent="submitForm">
          <div class="mb-3">
            <label for="departmentName" class="form-label">Department Name</label>
            <input
                type="text"
                class="form-control"
                id="departmentName"
                v-model="department.name"
                :class="{ 'is-invalid': errors.name }"
                required
            >
            <div class="invalid-feedback" v-if="errors.name">
              {{ errors.name }}
            </div>
          </div>
          <div class="mb-3">
            <label for="departmentCode" class="form-label">Department Code</label>
            <input
                type="text"
                class="form-control"
                id="departmentCode"
                v-model="department.code"
                :class="{ 'is-invalid': errors.code }"
                required
            >
            <div class="invalid-feedback" v-if="errors.code">
              {{ errors.code }}
            </div>
          </div>
          <div class="mb-3">
          <label for="description" class="form-label">Description</label>
            <textarea
                class="form-control"
                id="description"
                rows="3"
                v-model="department.description"
                :class="{ 'is-invalid': errors.description }"
                required
            ></textarea>
            <div class="invalid-feedback" v-if="errors.description">
              {{ errors.description }}
            </div>
          </div>
          <div class="d-flex justify-content-between">
            <button type="submit" class="btn btn-primary">Save Department</button>
            <router-link :to="{ name: 'DepartmentsList' }" class="btn btn-secondary">Cancel</router-link>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DepartmentAdd',
  data() {
    return {
      department: {
        name: '',
        code: '',
        description: ''
      },
      errors: {
        name: '',
        code: '',
        description: ''
      },
      isSubmitting: false,
      isEditing: false
    }
  },
  methods: {
    resetErrors() {
      this.errors = {
        name: '',
        code: '',
        description: ''
      }
    },
    async submitForm() {
      this.resetErrors()
      try {
        if (this.isSubmitting) return
        this.isSubmitting = true

        if (!this.department.name) {
          this.errors.name = 'Department name is required'
          return
        }

        if (!this.department.code) {
          this.errors.code = 'Department code is required'
          return
        }

        if (!this.department.description) {
          this.errors.description = 'Description is required'
          return
        }

        if (this.isEditing) {
          await this.$api.put(`/departments/${this.$route.params.id}`, this.department)
          alert('Department updated successfully!')
        } else {
          await this.$api.post('/departments', this.department)
          alert('Department created successfully!')
        }
        this.$router.push({name: 'DepartmentsList'})
      } catch (error) {
        console.error(`Error ${this.isEditing ? 'updating' : 'creating'} department:`, error)
        if (error.response?.data?.errors) {
          this.errors = error.response.data.errors
        }
      } finally {
        this.isSubmitting = false
      }
    },
    async loadDepartment() {
      try {
        const response = await this.$api.get(`/departments/${this.$route.params.id}`)
        this.department = response.data.data
        this.isEditing = true
      } catch (error) {
        console.error('Error loading department:', error)
        this.$router.push({name: 'DepartmentsList'})
      }
    }
  },
  created() {
    if (this.$route.params.id) {
      this.loadDepartment()
    }
  }
}
</script>

<style scoped>
.card {
  max-width: 800px;
  margin: 0 auto;
}

.form-label {
  font-weight: bold;
}
</style>
